@if (!error) {
  <div style="background-color: #161A29">
    <div class="video-container">
      <video #video id="video" autoplay muted></video>
    </div>
    @if (!error) {
      <div class="buttons-area">
        <div class="round-button close-button" (click)="close()">
          <img src="/assets/images/buttons/close.svg" alt="Icono">
        </div>
        <div class="round-button capture-tool-button material-icons notranslate md-36 cursorPointer" (click)="capture()"> photo_camera </div>
        @if (!error && hasMultipleCameras) {
          <div class="round-button capture-tool-button material-icons notranslate md-36 md-dark cursorDefault" (click)="switchCamera()"> cameraswitch </div>
        }
        @if (error || !hasMultipleCameras) {
          <div class="round-button capture-tool-button material-icons notranslate md-36 md-dark md-inactive cursorDefault"> cameraswitch </div>
        }
      </div>
    }
  </div>
}


@if (error) {
  <div>
    <!--<div class="video-container">
    <p class="text-danger mt-4">{{ error }}</p>
  </div>
  <div class="buttons-area">
    <div class="round-button close-button" (click)="exit()">
      <img src="/assets/images/buttons/close.svg" alt="Icono">
    </div>
  </div>-->
  <h1 mat-dialog-title>Error</h1>
  <div mat-dialog-content>
    <p>{{ error }}</p>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="close()">{{ 'MODAL.CLOSE' | translate}}</button>
  </div>
</div>
}


